/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import styles from '../BusinessVehicleInformation.module.scss'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'
import AddBusinessVehicleView from './AddBusinessVehicleView'
import BusinessVehicleListTable from './BusinessVehicleListTable'
import { useDispatch, useSelector } from 'react-redux'
import { setEditBusinessMasterNumber } from 'redux/actions';
const BusinessVehicleSummaryView = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const dispatch = useDispatch();
  const { editMasterNumber } = useSelector((state) => state.app.businessVehicleInformation);
  const onNextClick = () => {
    try {
      history.push(`/${i18n.language}${t('routes.addresses_to_change')}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const onBackClick = useCallback(() => {
    dispatch(setEditBusinessMasterNumber(editMasterNumber));
  }, [editMasterNumber, dispatch])

  return (
    <div>
      <div className="container">
        <div className="row">
          <BackAnchor onBackClick={onBackClick} />
        </div>
        <div className="row">
          <div className="col-xs-12">
            <h1>{t('business_vehicle_info_summary.title')}</h1>
          </div>
        </div>
        <BusinessVehicleListTable setIsError={setIsError} />
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <button
              className={['btn-lg btn-default', styles['next-button']].join(' ')}
              onClick={onNextClick}
              value={t('business_vehicle_info_summary.next')}
              name={t('business_vehicle_info_summary.next')}
            >
              {t('business_vehicle_info_summary.next')}
            </button>
          </div>
        </div>
        <div>
          <AddBusinessVehicleView t={t} setIsError={setIsError} />
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(BusinessVehicleSummaryView)
